import {isMobile} from '../helpers';

const SELECTORS = {
  LINE: '.vmf__timeline-line',
  LEFT: '.vmf__timeline-line-left',
  RIGHT: '.vmf__timeline-line-right',
  YEAR: '.vmf__timeline-year',
  LEFT_YEAR: '.vmf__timeline-line-left .vmf__timeline-year',
  RIGHT_YEAR: '.vmf__timeline-line-right .vmf__timeline-year'
};

function updatePageTimelinaDOM() {
  document.querySelectorAll(SELECTORS.LINE).forEach((element) => {
    let targetSelector = null;

    if (element.querySelector(SELECTORS.LEFT_YEAR)) {
      targetSelector = SELECTORS.RIGHT;
    } else if (element.querySelector(SELECTORS.RIGHT_YEAR)) {
      targetSelector = SELECTORS.LEFT;
    }

    if (targetSelector) {
      element
        .querySelector(SELECTORS.YEAR)
        .after(...element.querySelector(targetSelector).childNodes);
    }
  });
}

const PageTimelineComponent = () => {
  if (isMobile()) {
    updatePageTimelinaDOM();
  }
};

export const PageTimeline = () => {
  $(document).ready(() => PageTimelineComponent());
};
